import React from "react";
import AgentContainer from "../../../Containers/DashboardContainer/Body/AgentContainer";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next"; 
import "./CSS/agentsComponent.css";
function AgentsComponents(props) {
  const { t } = useTranslation(); 
  const chunkAgents = (agents) => {
    const entries = Object.entries(agents);
    const chunks = [];
    for (let i = 0; i < entries.length; i += 3) {
      chunks.push(entries.slice(i, i + 3));
    }
    return chunks;
  };
  return (
    <div className="agents-container">
      <div className="agents-container-wrapper">
      <div className="title-container" >
          {[1, 2, 3].map((_, index) => (
            <Stack key={index} className="title-block " horizontal
              wrap horizontalAlign="center" tokens={{ childrenGap: -3 }}
            >
              <div className="title-agent-details  " style={{ width: '30%' }}>

              </div>
              <div className="title-agent-details" >
              <span>{t("AGENTS.CALLS")}</span>
                <span>{t("AGENTS.TODAY")} </span>
                
              </div>
              <div className="title-agent-details" >
                <span> {t("AGENTS.CALLS")}</span>
                <span>{t("AGENTS.MISSED")}</span>
              </div>
            
              <div className="title-agent-details">
                <span>{t("AGENTS.TOTAL")}</span>
                <span>{t("AGENTS.CALLS")}</span>
              </div>
              <div className="title-agent-details" >
                <span>{t("AGENTS.DURATION")}</span>
                <span>{t("AGENTS.OF_CALLS")}</span>
              </div>
            </Stack>
          ))}
        </div>
        <div className="agents">
         {props.supervisedAgentDetails &&
          Object.keys(props.supervisedAgentDetails).length > 0 ? (
            chunkAgents(props.supervisedAgentDetails).map((chunk, rowIndex) => (
              <Stack
                key={rowIndex}
                className="agent-card"
                horizontal
                horizontalAlign="space-between"
                tokens={{ childrenGap: -3 }}
              >
                {chunk.map(([agentId, agent]) => (
                  <div key={agentId} className="agent-detail-container">
                    <AgentContainer
                      agent={agent}
                      agentId={agentId}
                      signalRConnection={props.signalRConnection}
                    />
                  </div>
                ))}
              </Stack>
            ))
          ) : (
            <></>
          )}
         
          </div>
          
      </div>
    </div>
  );
}

export default AgentsComponents;
